export default __webpack_public_path__ + "static/media/carousel1.e78f081c.jpg";